/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Welcome_Accreditation_DescriptionInputs */

const en_welcome_accreditation_description = /** @type {(inputs: Welcome_Accreditation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Before you can access ${i?.companyName}, we first need to confirm the following to ensure you qualify as an accredited investor.`)
};

/**
* | output |
* | --- |
* | "Before you can access {companyName}, we first need to confirm the following to ensure you qualify as an accredited investor." |
*
* @param {Welcome_Accreditation_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const welcome_accreditation_description = /** @type {((inputs: Welcome_Accreditation_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_description(inputs)
});